module.exports = __webpack_public_path__ + "img/yt-hero-mobile-eng.839f90ec.png";